export {
  default,
  getServerSideProps,
} from '@klokhuis/modules/Properties/pages/Listings/Listings.page';
